import { Grid, Typography } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../assets/css/header.css";
import { logout } from "../model";
import { useDispatch } from "react-redux";

const Header = ({ user }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    if (location.pathname.startsWith("/practice")) {
      navigate("/");
    } else {
      dispatch(logout());
    }
  };

  const getTitle = () => {
    if (user && user.admin === 0) {
      return "Apertura nuova pratica";
    } else if (user && user.admin === 1) {
      return "Dashboard Admin";
    }

    return "Apertura nuova pratica";
  };
  return (
    <Grid
      container
      className="bg-blue-dark"
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "5px 0px",
        alignItems: "center",
      }}
    >
      <Grid
        item
        xs={2}
        md={1}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="logo-lexia-header" />
      </Grid>

      <Grid
        item
        xs={8}
        md={10}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography className="color-light title-header">
          {getTitle()}
        </Typography>
      </Grid>

      <Grid
        item
        xs={2}
        md={1}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          onClick={handleLogout}
          className="icon-logout container-icon"
          aria-label="Logout"
        ></div>
      </Grid>
    </Grid>
  );
};

export default Header;
